<ng-container *ngIf="clickable; else defaultIcon">
  <div
    class="clickable-icon"
    [ngStyle]="{ lineHeight: size }"
    (click)="onClicked($event)"
    aria-hidden="true"
  >
    <ng-container *ngTemplateOutlet="defaultIcon"></ng-container>
    <ng-content></ng-content>
  </div>
</ng-container>

<ng-template #defaultIcon>
  <span
    *ngIf="name"
    nz-icon
    [ngStyle]="{ fontSize: size, color: color }"
    [nzType]="name"
    [nzTheme]="iconTheme"
    [nzSpin]="isSpining"
    uiRipple
    [rippleDisabled]="!clickable"
  >
  </span
></ng-template>
